import type { Component, Entity2D } from '../../odie';

import { KappaBlockProps, ModeBlockOptionDef } from '../defs/block';
import { KappaBlockView } from '../views/blocks/KappaBlockView';

// types
//-----------------------------------------------------------------------------
export type KappaBlockComponentOptions = {
  props: KappaBlockProps;
  option?: number;
};

export type KappaBlockType = 'hard' | 'soft';

/*
    kappa block component
*/
export class KappaBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockKappa';

  // fields
  private _state!: KappaBlockType;
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: KappaBlockView;

  // properties
  //-------------------------------------------------------------------------
  private props!: KappaBlockProps;
  // count
  public get state(): KappaBlockType {
    return this._state;
  }

  public set state(state: KappaBlockType) {
    this._state = state;
    // update view
    this.view.statusSprite = state;
  }

  // impl
  //-------------------------------------------------------------------------
  public init(options: KappaBlockComponentOptions): void {
    const optionDef = options.props.options![
      options.option || 0
    ] as ModeBlockOptionDef;

    this.view = new KappaBlockView({ ...options.props, width: 0, height: 0 });

    this.props = options.props;

    // set initial state
    this.state = optionDef.mode;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState(): number {
    const options = this.props.options as ModeBlockOptionDef[];
    return options.findIndex((opt) => opt.mode === this.state);
  }
}
